import type {
    ConversionsInterface,
    ExistsProductOptionsInterface,
    ProductInterface,
    ProductListMiniInterface
} from "~~/server/types/Products";
import type { PageInterface } from "#server/types/page";

export function useProduct() {
    type SelectedOptions = Record<number, number | number[]>;
    const productsStore=useProductStore();

    const getMaxAvailableCountPcs = (
        product: ProductInterface,
        selected: SelectedOptions
    ): number => {
        // стартов лимит – наличност на продукта (ако има)
        let max: number | null = product.count ?? null;

        for (const option of product.options) {
            const selectedValue = selected[option.id];
            if (selectedValue == null) continue;

            const selectedIds = Array.isArray(selectedValue)
                ? selectedValue
                : [selectedValue];

            for (const valueId of selectedIds) {
                const v = option.values.find(val => val.id === valueId);
                if (!v) continue;

                // ако опцията няма count → не ограничава
                if (v.count == null) continue;

                if (max === null) {
                    max = v.count;
                } else {
                    max = Math.min(max, v.count);
                }
            }
        }

        return max ?? 0;
    };

    const getBasePrice = ( conversion: ConversionsInterface, options: ExistsProductOptionsInterface[], selected: SelectedOptions ): number => {
        return conversion.price;
    };

    const getOptionExtras = (
        basePrice: number,
        productOptions: ExistsProductOptionsInterface[],
        selected: SelectedOptions
    ): number => {
        let extra = 0;

        for (const option of productOptions) {
            const selectedValue = selected[option.id];
            if (selectedValue == null) continue;

            const selectedIds = Array.isArray(selectedValue)
                ? selectedValue
                : [selectedValue];

            for (const valueId of selectedIds) {
                const v = option.values.find(val => val.id === valueId);
                if (!v) continue;

                if (v.added_price !== null) {
                    extra += v.added_price;
                }
                else if (v.added_percent !== null) {
                    extra += (basePrice * v.added_percent) / 100;

                }
            }
        }

        return extra;
    };

    const colors=ref({
        loading:false,
        list:[] as ProductListMiniInterface[],
        load:async(product:ProductInterface)=>{
            colors.value.loading=true;
            try {
                colors.value.list = await productsStore.loadColors(product.id)
            }
            finally {
                colors.value.loading=false;
            }
        }
    })
  const related=ref({
    loading:false,
    list:[] as ProductListMiniInterface[],
    load:async(product:ProductInterface,limit:number=5)=>{
      related.value.loading=true;
      try {
        related.value.list = await productsStore.loadRelated(product.id, product.categories_list?.[0]?.id || 0,limit)
      }
      finally {
        related.value.loading=false;
      }
    }
  })
  const pages=ref({
    loading:false,
    list:[] as PageInterface[],
    load:async(product:ProductInterface)=>{
      pages.value.loading=true;
      try {
        pages.value.list = await productsStore.loadPages(product.id)
      }
      finally {
        pages.value.loading=false;
      }
    }
  })
    return { getMaxAvailableCountPcs,getBasePrice,getOptionExtras,colors,related,pages };
}
